// extracted by mini-css-extract-plugin
export default {"linkContainer":"header_linkContainer__nS5Eg","activeLink":"header_activeLink__6v0HT"};